type ServerTimestamp = {
  seconds?: number | null
}

export type BillTimeSource = {
  type?: number | null
  billTime?: ServerTimestamp | null
  timeInfo?: {
    endTime?: ServerTimestamp | null
  } | null
}

const ONGOING_BILL_TYPE = 1

function getValidSeconds(timestamp?: ServerTimestamp | null) {
  const seconds = timestamp?.seconds

  return typeof seconds === 'number' && Number.isFinite(seconds) && seconds > 0
    ? seconds
    : undefined
}

export function getBillDisplayTimeSeconds(bill: BillTimeSource) {
  if (bill.type === ONGOING_BILL_TYPE) return undefined

  return getValidSeconds(bill.timeInfo?.endTime) ?? getValidSeconds(bill.billTime)
}
